// extracted by mini-css-extract-plugin
export default {"empty":"styles_empty__4QJt9","icon":"styles_icon__jI0U3","title":"styles_title__Znr8z","subtitle":"styles_subtitle__m31iJ"};